import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { problemQuestions } from '../data/content';
export function Problem() {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-182" data-mp="2bfzjg0eqorw8">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-183" data-mp="2bfg5eus7mnnh">
        <SectionHeading eyebrow="La misma pérdida, distintas edades" title={<>
              Un niño de 8 años y un adolescente de 16{' '}
              <span className="italic text-gold-700" data-id="element-185" data-mp="26h67wdj0jayp">no viven el duelo de la misma manera</span>
            </>} intro={<>
              <p data-id="element-186" data-mp="1sn54h6h48zs0">
                Un niño puede necesitar dibujar o representar aquello que todavía no sabe explicar
                con palabras.
              </p>
              <p data-id="element-187" data-mp="1is3gidyku3r0">
                Un adolescente puede sentir esas actividades infantiles y necesitar un espacio más
                privado e introspectivo.
              </p>
            </>} data-id="element-184" data-mp="2gdreh3aoku4n" />

        <p className="mx-auto mt-12 max-w-narrow text-center text-lg font-semibold text-plum-700" data-id="element-188" data-mp="t8lyd5k72yb7">
          Y cuando la pérdida acaba de ocurrir, aparecen otras preguntas:
        </p>

        <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-189" data-mp="129k884hbe01p">
          {problemQuestions.map(question => <li key={question} className="flex items-start gap-3 rounded-lg bg-white px-5 py-5 shadow-card ring-1 ring-plum-100" data-id="element-190" data-mp="xc1um0scqwnd">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-plum-300" aria-hidden="true" data-id="element-191" data-mp="5ldveua8o1cc" />
              <span className="font-display text-lg font-bold leading-snug text-plum-700" data-id="element-192" data-mp="jcsqhzhf7szr">
                {question}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-193" data-mp="3n0c8wb0hgy3g">
          Buscar un recurso diferente para cada edad y cada momento puede convertirse en horas de
          búsqueda e improvisación.
        </p>

        <p className="mt-9 text-center font-display text-2xl font-extrabold italic text-gold-700 md:text-3xl" data-id="element-194" data-mp="1ly39g826qq4o">
          Por eso creamos:
        </p>
      </div>
    </section>;
}